import {getData, postData} from './redux_data';
import {
    GET_SUB_FAMILIA,
    MODIFY_SUB_FAMILIA,
    ADD_SUB_FAMILIA,
    DELETE_SUB_FAMILIA,
    UPDATE_SUB_FAMILIA,
} from '../constants/action_types';

export function getSubFamiliaList() {
    return getData('VSubFamilias', GET_SUB_FAMILIA);
}

export function modifySubFamilia(subFamilia) {
    return (dispatch, getState) => {
        dispatch({ type: MODIFY_SUB_FAMILIA, payload: subFamilia });
    }
}

export function addSubFamilia(subFamilia) {
    return (dispatch, getState) => {
        dispatch({ type: ADD_SUB_FAMILIA, payload: subFamilia });
    }
}

export function removeSubFamilia(subFamilia) {
    return (dispatch, getState) => {
        dispatch({ type: DELETE_SUB_FAMILIA, payload: subFamilia });
    }
}

export function updateSubFamiliaDB (subFamilia) {
    return postData('CvSubfamilias/subfamilias', UPDATE_SUB_FAMILIA, subFamilia, 'Sub-familias actualizadas', undefined);
}

